import {useQuery} from '@tanstack/vue-query';
import {storeToRefs} from 'pinia';
import {computed} from 'vue';
import {useBookingForStore} from '@/stores/bookingForStore';
import {useUserStore} from '@/stores/userStore';
import {getSpaceStructure} from '@/api/repositories/booking/SpaceRepository';
import {spaceStructureQueryKey} from '@/api/queries/keys/spaceKeys';
import type {SpaceStructure} from '@/api/models/booking/spaceModels';

export function useSpaceStructureQuery() {
    const {effectiveBookingForId} = storeToRefs(useBookingForStore());
    const {user} = storeToRefs(useUserStore());
    const userId = computed(() => user.value?.id ?? null);

    return useQuery<SpaceStructure | null>({
        queryKey: spaceStructureQueryKey(userId, effectiveBookingForId),
        queryFn: () => getSpaceStructure(effectiveBookingForId.value ?? undefined),
        enabled: computed(() => !!userId.value),
    });
}
